var x = y => { var x = {}; __webpack_require__.d(x, y); return x; }
var y = x => () => x
const __WEBPACK_NAMESPACE_OBJECT__ = x({ ["of"]: () => __WEBPACK_EXTERNAL_MODULE_rxjs__.of });